export default __webpack_public_path__ + "static/media/solucao-08.b531dc29.webp";